import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref } from 'vue';

import {
  Heading,
  ListDisplay,
  MessageFoundation,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { TotalWithdrawModal } from './components';

import { moneyFormat } from '@/modules/common/helpers/currency';
import { IWithdrawDetails } from '@/modules/transaction/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Preview',
  setup(__props) {

const fetchWithdraw = inject('fetchWithdraw', () => ({}));

const withdrawDetails = inject('withdrawDetails') as Ref<IWithdrawDetails>;
const isFetchingWithdraw = inject('isFetchingWithdraw') as Ref<boolean>;
const amountValue = inject('amountValue') as Ref<number>;

const isTotalWithdrawModalOpen = ref(false);

const total = computed(() => {
  return moneyFormat(amountValue.value);
});

const disclaimer = computed(() => {
  return 'O valor líquido do resgate é uma estimativa e pode variar conforme cotação, impostos e taxas no dia da liquidação.';
});

const previewDetails = computed(() => {
  return [
    {
      title: 'Origem',
      value: withdrawDetails.value.portfolioName
    },
    {
      title: 'Destino',
      value: 'Conta Warren'
    },
    {
      title: 'Previsão de resgate',
      value: withdrawDetails.value.expectedRedemptionDate
    },
    {
      title: 'Valor bruto',
      value: total.value
    }
  ];
});

function handleClick() {
  if (amountValue.value === withdrawDetails.value.totalBalance.value) {
    isTotalWithdrawModalOpen.value = true;
    return;
  }

  fetchWithdraw();
}

function handleConfirm() {
  isTotalWithdrawModalOpen.value = false;

  fetchWithdraw();
}

return { __sfc: true,fetchWithdraw, withdrawDetails, isFetchingWithdraw, amountValue, isTotalWithdrawModalOpen, total, disclaimer, previewDetails, handleClick, handleConfirm, Heading, ListDisplay, MessageFoundation, ButtonContainer, ButtonPrimary, TotalWithdrawModal }
}

})